<div class="footer" [class.footer--modern]="appearance === 'modern'">
  <div class="d-flex justify-center align-center footer-conteudo conteudo">
    <div class="d-flex justify-space-between conteudo-botoes"
         [ngClass]="{ 'justify-center': !allowIntegrationSap && !allowCancelSap }">
      <button *ngIf="showBackButton" [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--secondary' : 'back'" [routerLink]="[link]">Voltar</button>

      <button id="changeStageButton"
              [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--primary' : 'save'"
              *ngIf="canEditContrato"
              (click)="enterEditMode()">
        Editar Contrato
      </button>

      <button [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--secondary' : 'back'"
              *ngIf="!isLotRoute() && currentMode === 'editar'"
              (click)="cancelEdit()">
        Cancelar
      </button>

      <button [ngClass]="appearance === 'modern' ? 'ui-btn footer-btn--danger ml-20' : 'back ml-20'"
              *ngIf="allowCancelBatch && route === 'Lote'"
              (click)="cancelBatch()">
        Cancelar Lote
      </button>

      <button [ngClass]="appearance === 'modern' ? 'ui-btn footer-btn--danger ml-20' : 'back ml-20'"
              *ngIf="allowCancelAllContractsBatch && route === 'Lote'"
              (click)="cancelAllContractsBatchDialogOpen()">
        Cancelar lote
      </button>

      <button [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--secondary ml-20' : 'back ml-20'"
              *ngIf="allowReturnStatus && route === 'Lote'"
              (click)="returnBatchStatus()">
        Voltar Status
      </button>

      <button [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--secondary ml-20' : 'back ml-20'"
              *ngIf="route === 'Lote'"
              (click)="getBatchEventLogs()">
        Logs
      </button>

      <ng-container *appIsAllowed="['modfin_faturamento', 'modfin_repasse']">
        <button [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--primary' : 'save'" *ngIf="showButton" (click)="saveForm()">
          Salvar Dados
        </button>
      </ng-container>

      <!-- botões  pag detalhes-lotes -->
      <div class="d-flex" *ngIf="route === 'Lote'">
        <div class="d-flex ml-20">
          <button *ngIf="allowIntegrationSap"
                  [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--primary' : 'integrate-sap'"
                  (click)="integrateSAP()">
            Integrar OMIE
          </button>
        </div>

        <div class="d-flex ml-20">
          <button *ngIf="allowLiberacaoManual"
                  [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--primary' : 'integrate-sap'"
                  (click)="handleLiberarManual()">
            Liberar Manual
          </button>
        </div>

        <div class="d-flex ml-20">
          <button *ngIf="allowReintegrationSap"
                  [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--primary' : 'integrate-sap'"
                  (click)="reSendIntegrateSap()">
            Re-Integrar OMIE
          </button>
        </div>

        <div class="d-flex ml-20">
          <button *ngIf="allowRefreshNFENumber"
                  [ngClass]="appearance === 'modern' ? 'ui-btn ui-btn--primary' : 'integrate-sap'"
                  (click)="refreshNFENumber()"
                  [ngStyle]="appearance === 'modern' ? {} : { width: '48px' }">
            <app-svg-icon src="../../../../assets/icons/reload-icon.svg "
                          width="16px"
                          height="16px">
            </app-svg-icon>
            <span *ngIf="appearance === 'modern'">Reprocessar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
